export enum diversKeys {
  keyCameraRotate = "gimbalRotate",
  keyTriggerReach = "reachPoint" ,

  keyEndShot ="endshot",
}
export enum KeyAction {
  startvideo = "startRecord",
  stopvideo = "stopRecord",

  starttimedshot = "multipleTiming",
  startdistshot = "multipleDistance",


  wait = "hover",

  droneyaw = "rotateYaw",
  cameraTilt = "gimbalTilt",
  cameraYaw = "gimbalYaw",
  cameraZoom = "zoom",
  panorama = "panoShot",

  snapshot = "takePhoto",
  snapshotfixedangle = "orientedShoot",
  directory = "customDirName",
}

export const TemplateSuitePayloadParam = {
  focusMode:"firstPoint",
  meteringMode:"average",
  returnMode:"singleReturnFirst",
  samplingRate:240000,
  scanningMode:"repetitive",
}

export const TemplatePlacemark = {  
    Point: {
        coordinates: []                
    },
    index: 0,                           // mettre à jour avec la bonne position dans l'enchainement 
    ellipsoidHeight: 330.66880427196,     // => à recalculer avant de save
    height: 282,                          // => à recalculer avant de save
    waypointSpeed: 10,                    // => mm valeur que ce qui sort de GlobalSettings 'Folder -> autoFlightSpeed'
    waypointHeadingParam: {
        waypointHeadingMode: "followWayline",       // => mm valeur que ce qui sort de GlobalSettings 'Folder -> globalWaypointHeadingParam -> waypointHeadingMode'
        waypointHeadingAngle: 0,
        waypointPoiPoint: "0.000000,0.000000,0.000000",
        waypointHeadingPathMode: "followBadArc",
        waypointHeadingPoiIndex: 0
    },
    waypointTurnParam: {
        waypointTurnMode: "toPointAndStopWithDiscontinuityCurvature", // => mm valeur que ce qui sort de GlobalSettings 'Folder -> globalWaypointTurnMode'
        waypointTurnDampingDist: 0.2
    },
    useGlobalHeight: 1,
    useGlobalSpeed: 1,
    useGlobalHeadingParam: 1,
    useGlobalTurnParam: 1,
    useStraightLine: 1,
    isRisky: 0,
    actionGroup :[]
};

export const TemplateActionTrigger = {
  'multipleTiming':{ 
    actionTriggerType:"multipleTiming",
    actionTriggerParam:3,      // valeur à bouger  en s 
  },
  'multipleDistance':{ 
    actionTriggerType:"multipleDistance",
    actionTriggerParam:10,      // valeur à bouger en metres 
  },
  '':{ 
    actionTriggerType:"reachPoint", 
  }
};

export const TemplateActionsGroup = {
  actionGroupId: 0,
  actionGroupStartIndex: 0,
  actionGroupEndIndex: 0,
  actionGroupMode: "sequence",
  actionTrigger:{},
  action: {}
}

export const TemplateAction = {
  "startRecord" :{
    actionId: 0,
    actionActuatorFunc : "startRecord",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0,
      useGlobalPayloadLensIndex: 1 // si on ne choisit pas de caméras => 1    si on choisit les caméras => 0
      // si cameras choisies => payloadLensIndex: key_camera, key_camera 
      // si nom défini => fileSuffix : .....
    }

  },
  "stopRecord" :{
    actionId: 0,
    actionActuatorFunc : "stopRecord",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0
    }
  },
  "multipleTiming":{
    actionId: 0,
    actionActuatorFunc : "takePhoto",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0,
      useGlobalPayloadLensIndex: 1 // si on ne choisit pas de caméras => 1    si on choisit les caméras => 0
      // si cameras choisies => payloadLensIndex: key_camera, key_camera 
    }
  },
  "multipleDistance":{
    actionId: 0,
    actionActuatorFunc : "takePhoto",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0,
      useGlobalPayloadLensIndex: 1 // si on ne choisit pas de caméras => 1    si on choisit les caméras => 0
      // si cameras choisies => payloadLensIndex: key_camera, key_camera 
    }
  },
  "hover" : { 
    actionId: 0,
    actionActuatorFunc : "hover",
    actionActuatorFuncParam: {
      hoverTime: 1
    }
  },
  "rotateYaw" : {
    actionId: 0,
    actionActuatorFunc : "rotateYaw",
    actionActuatorFuncParam: {
      aircraftHeading: 0,       /// => cette valeur à bouger 
      aircraftPathMode: "counterClockwise"
    }
  },
  "gimbalTilt": {
    actionId: 0,
    actionActuatorFunc : "gimbalRotate",
    actionActuatorFuncParam: {
      gimbalHeadingYawBase: "north",
      gimbalRotateMode: "absoluteAngle",
      gimbalPitchRotateEnable: 1,
      gimbalPitchRotateAngle: 0, // => cette valeur à bouger
      gimbalRollRotateEnable: 0,
      gimbalRollRotateAngle: 0,
      gimbalYawRotateEnable: 0,
      gimbalYawRotateAngle: 0,
      gimbalRotateTimeEnable: 0,
      gimbalRotateTime: 0,
      payloadPositionIndex: 0
    }
  },
  "gimbalYaw": {
    actionId: 0,
    actionActuatorFunc : "gimbalRotate",
    actionActuatorFuncParam: {
      gimbalHeadingYawBase: "north",
      gimbalRotateMode: "absoluteAngle",
      gimbalPitchRotateEnable: 0,
      gimbalPitchRotateAngle: 0,
      gimbalRollRotateEnable: 0,
      gimbalRollRotateAngle: 0,
      gimbalYawRotateEnable: 1,
      gimbalYawRotateAngle: 0, // => cette valeur à bouger
      gimbalRotateTimeEnable: 0,
      gimbalRotateTime: 0,
      payloadPositionIndex: 0
    }
  },
  "zoom":{    
    actionId: 0,
    actionActuatorFunc : "zoom",
    actionActuatorFuncParam: {
      focalLength: 48 ,      // => cette valeur à bouger 
      isUseFocalFactor: 0,
      payloadPositionIndex: 0
    }
  },
  "panoShot":{
    actionId: 0,
    actionActuatorFunc : "panoShot",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0,
      useGlobalPayloadLensIndex: 0,
      panoShotSubMode : "panoShot_360",
    }
  },
  "takePhoto":{
    actionId: 0,
    actionActuatorFunc : "takePhoto",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0,
      useGlobalPayloadLensIndex: 1    // si on ne choisit pas de caméras => 1    si on choisit les caméras => 0
      // si cameras choisies => payloadLensIndex: key_camera, key_camera 
      // si nom défini => fileSuffix : .....
    }
  },
  "orientedShoot":{
    actionId: 0,
    actionActuatorFunc : "orientedShoot",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0,
      useGlobalPayloadLensIndex: 1,
      // si on ne choisit pas de caméras => 1    si on choisit les caméras => 0
      // si cameras choisies => payloadLensIndex: key_camera, key_camera 
      // si nom défini => orientedFileSuffix : .....
      gimbalPitchRotateAngle: 0,
      gimbalYawRotateAngle: 0,
      focalLength: 48,
      aircraftHeading: 0,
      focusX:0,
      focusY:0,
      focusRegionWidth:0,
      focusRegionHeight:0,
      accurateFrameValid:0,
      targetAngle:0,
      actionUUID:"",
      imageWidth:0,
      imageHeight:0,
      AFPos:0,
      gimbalPort:0,
      orientedCameraType: "",
      orientedFilePath:"",
      orientedFileMD5:"",
      orientedFileSize:0,
      orientedPhotoMode:"normalPhoto",
    },
    actionActuatorFuncParamSave : {
      gimbalPitchRotateAngle: 0,
      gimbalYawRotateAngle: 0,
      focalLength: 48,
      aircraftHeading: 0,
      isInit:false,
    }
  },
  "customDirName": {
    actionId: 0,
    actionActuatorFunc : "customDirName",
    actionActuatorFuncParam: {
      payloadPositionIndex: 0
      // si nom défini => directoryName :....
    }
  },
};


export const Actions={
  "startRecord":{
   // key:'startvideo',
    name:'Démarrer enregistrement vidéo',
    img:  
    '<svg  xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 20 20"  version="1.1" >  '+  
      '<g   transform="translate(-98.009448,-87.514304)"> '+  
        '<path d="m 115.91048,93.836614 c -0.38653,-0.23564 -0.85474,-0.25425 -1.25987,-0.0527 l -2.49288,1.08522 v -1.30742 c 0,-0.93948 -0.7648,-1.70428 -1.70428,-1.70428 h -9.36997 c -0.93948,0 -1.704276,0.7648 -1.704276,1.70428 v 7.527126 c 0,0.93949 0.764796,1.70429 1.704276,1.70429 h 9.37208 c 0.93949,0 1.70429,-0.7648 1.70429,-1.70429 v -1.375616 l 2.47634,1.121386 c 0.19017,0.0982 0.39378,0.14572 0.59841,0.14572 0.23048,0 0.46302,-0.063 0.66971,-0.1881 0.39688,-0.23771 0.63458,-0.6563 0.63458,-1.119316 l -10e-4,-4.72228 c 0,-0.46096 -0.23565,-0.87643 -0.62735,-1.11414 z m -5.45809,7.898336 h -9.36891 c -0.35761,0 -0.64595,-0.28834 -0.64595,-0.64595 v -7.530306 c 0,-0.35761 0.28834,-0.64595 0.64595,-0.64595 h 9.37208 c 0.35761,0 0.64596,0.28834 0.64596,0.64595 v 2.11976 0.003 5.405436 c -10e-4,0.35658 -0.29147,0.64802 -0.64905,0.64802 z m 5.02708,-2.058766 c 0,0.12195 -0.0744,0.185 -0.11885,0.21187 -0.0455,0.0269 -0.1354,0.063 -0.24392,0.005 -0.0103,-0.005 -0.0207,-0.0103 -0.032,-0.0155 l -2.92602,-1.32808 v -2.52905 l 2.92893,-1.27537 c 0.0103,-0.005 0.0207,-0.0103 0.032,-0.0155 0.10542,-0.0558 0.19534,-0.0186 0.24082,0.008 0.0455,0.0269 0.11885,0.0899 0.11885,0.20877 z" style="stroke-width:0.264583" /> '+  
      '</g> '+  
    '</svg> ',
  },
  "stopRecord":{
  //  key:'stopvideo',
    name:'Arrêter enregistrement vidéo',
    img:
      '<svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" version="1.1" > '+
        '<g  transform="translate(-98.009448,-87.514304)"> '+
          '<path  d="m 115.91048,93.836614 c -0.38653,-0.23564 -0.85474,-0.25425 -1.25987,-0.0527 l -2.49288,1.08522 v -1.30742 c 0,-0.93948 -0.7648,-1.70428 -1.70428,-1.70428 h -9.36997 c -0.93948,0 -1.704276,0.7648 -1.704276,1.70428 v 7.527126 c 0,0.93949 0.764796,1.70429 1.704276,1.70429 h 9.37208 c 0.93949,0 1.70429,-0.7648 1.70429,-1.70429 v -1.375616 l 2.47634,1.121386 c 0.19017,0.0982 0.39378,0.14572 0.59841,0.14572 0.23048,0 0.46302,-0.063 0.66971,-0.1881 0.39688,-0.23771 0.63458,-0.6563 0.63458,-1.119316 l -10e-4,-4.72228 c 0,-0.46096 -0.23565,-0.87643 -0.62735,-1.11414 z m -5.45809,7.898336 h -9.36891 c -0.35761,0 -0.64595,-0.28834 -0.64595,-0.64595 v -7.530306 c 0,-0.35761 0.28834,-0.64595 0.64595,-0.64595 h 9.37208 c 0.35761,0 0.64596,0.28834 0.64596,0.64595 v 2.11976 0.003 5.405436 c -10e-4,0.35658 -0.29147,0.64802 -0.64905,0.64802 z m 5.02708,-2.058766 c 0,0.12195 -0.0744,0.185 -0.11885,0.21187 -0.0455,0.0269 -0.1354,0.063 -0.24392,0.005 -0.0103,-0.005 -0.0207,-0.0103 -0.032,-0.0155 l -2.92602,-1.32808 v -2.52905 l 2.92893,-1.27537 c 0.0103,-0.005 0.0207,-0.0103 0.032,-0.0155 0.10542,-0.0558 0.19534,-0.0186 0.24082,0.008 0.0455,0.0269 0.11885,0.0899 0.11885,0.20877 z" style="stroke-width:0.264583" /> '+
        '</g> '+
        '<g > '+
          '<rect  width="0.8"  height="19.514767"  x="12.656411"  y="-11.76042" transform="matrix(0.49228752,0.87043265,-0.75560115,0.65503199,0,0)" /> '+
        '</g> '+
      '</svg>'
  },
  "multipleTiming":{
   // key:'starttimedshot',
    name:'Start Timed Interval Shot',
    img: 
    '<svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 23.8125 23.8125"  version="1.1" > '+
      '<g > '+
        '<g transform="matrix(0.22222222,0,0,0.22222222,0.498884,0.96775804)" > '+
          '<path d="m 43.689453,0 c -0.483,0 -0.875,0.39004688 -0.875,0.87304688 V 22.71875 c 0,0.483 0.392,0.873047 0.875,0.873047 h 2.621094 c 0.483,0 0.873047,-0.390047 0.873047,-0.873047 V 4.4277344 C 68.576592,5.5667344 85.632812,23.329 85.632812,45 c 0,3.068197 -0.352999,6.053883 -1.003906,8.927734 h 4.466797 C 89.683122,51.041002 90,48.057644 90,45 90,20.187 69.813,0 45,0 Z M 13.179688,13.541016 c -0.22275,5e-4 -0.444329,0.08822 -0.611329,0.261718 C 4.45636,22.228734 0,33.271 0,45 c 0,24.813 20.188,45 45,45 4.467599,0 8.780639,-0.664582 12.857422,-1.882812 V 83.53125 C 53.813309,84.88557 49.493988,85.632812 45,85.632812 22.596,85.632812 4.3671875,67.404 4.3671875,45 c 0,-10.562 4.0040159,-20.508422 11.2910155,-28.107422 0.334,-0.348 0.333176,-0.900187 -0.0078,-1.242187 l -1.853516,-1.853516 c -0.171,-0.1705 -0.394439,-0.256359 -0.617187,-0.255859 z" transform="translate(4.9999991,4.9999998)" /> '+
          '<path d="m 45.939,48.411 c -0.192,0.494 -0.308,1.026 -0.308,1.589 0,2.413 1.955,4.368 4.368,4.368 0.563,0 1.095,-0.114 1.588,-0.308 l 5.211,5.21 c 0.342,0.341 0.895,0.341 1.236,0 l 1.235,-1.235 c 0.341,-0.342 0.341,-0.895 0,-1.236 l -5.211,-5.211 c 0.193,-0.493 0.309,-1.026 0.309,-1.588 0,-2.413 -1.955,-4.369 -4.368,-4.369 -0.563,0 -1.095,0.115 -1.589,0.309 L 31.464,28.993 c -0.341,-0.341 -0.894,-0.341 -1.234,0 l -1.236,1.236 c -0.342,0.341 -0.342,0.895 0,1.235 z" /> '+
        '</g> '+
      '</g> '+
      '<g > '+
        '<text   style="font-weight:bold;font-size:7px;font-family:Arial;"  transform="translate(0.09449405,-1.4174107)">'+
          '<tspan  x="15.974609"  y="21.920251"> '+ 
            '<tspan >T</tspan> '+
          '</tspan> '+
        '</text> '+
      '</g> '+
    '</svg>'
    
  },
  "multipleDistance":{
   // key:'startdistshot',
    name:'Start Distance Interval Shot',
    img:
      '<svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 23.8125 23.8125"  version="1.1" > '+
        '<g > '+
          '<g transform="matrix(0.22222222,0,0,0.22222222,0.498884,0.96775804)" > '+
            '<path d="m 43.689453,0 c -0.483,0 -0.875,0.39004688 -0.875,0.87304688 V 22.71875 c 0,0.483 0.392,0.873047 0.875,0.873047 h 2.621094 c 0.483,0 0.873047,-0.390047 0.873047,-0.873047 V 4.4277344 C 68.576592,5.5667344 85.632812,23.329 85.632812,45 c 0,3.068197 -0.352999,6.053883 -1.003906,8.927734 h 4.466797 C 89.683122,51.041002 90,48.057644 90,45 90,20.187 69.813,0 45,0 Z M 13.179688,13.541016 c -0.22275,5e-4 -0.444329,0.08822 -0.611329,0.261718 C 4.45636,22.228734 0,33.271 0,45 c 0,24.813 20.188,45 45,45 4.467599,0 8.780639,-0.664582 12.857422,-1.882812 V 83.53125 C 53.813309,84.88557 49.493988,85.632812 45,85.632812 22.596,85.632812 4.3671875,67.404 4.3671875,45 c 0,-10.562 4.0040159,-20.508422 11.2910155,-28.107422 0.334,-0.348 0.333176,-0.900187 -0.0078,-1.242187 l -1.853516,-1.853516 c -0.171,-0.1705 -0.394439,-0.256359 -0.617187,-0.255859 z" transform="translate(4.9999991,4.9999998)" /> '+
            '<path d="m 45.939,48.411 c -0.192,0.494 -0.308,1.026 -0.308,1.589 0,2.413 1.955,4.368 4.368,4.368 0.563,0 1.095,-0.114 1.588,-0.308 l 5.211,5.21 c 0.342,0.341 0.895,0.341 1.236,0 l 1.235,-1.235 c 0.341,-0.342 0.341,-0.895 0,-1.236 l -5.211,-5.211 c 0.193,-0.493 0.309,-1.026 0.309,-1.588 0,-2.413 -1.955,-4.369 -4.368,-4.369 -0.563,0 -1.095,0.115 -1.589,0.309 L 31.464,28.993 c -0.341,-0.341 -0.894,-0.341 -1.234,0 l -1.236,1.236 c -0.342,0.341 -0.342,0.895 0,1.235 z" /> '+
          '</g> '+
        '</g> '+
        '<g > '+
          '<text   style="font-weight:bold;font-size:7px;font-family:Arial;"  transform="translate(0.09449405,-1.4174107)">'+
            '<tspan  x="15.974609"  y="21.920251"> '+ 
              '<tspan   >D</tspan> '+
            '</tspan> '+
          '</text> '+
        '</g> '+
      '</svg>'
  },
  "endshot":{
  //  key:'endshot',
    name:'End Interval Shot',
    img:
      '<svg   xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 23.8125 23.8125" version="1.1" >  '+
        '<g > '+
          '<g  transform="matrix(0.83989502,0,0,0.83989502,1.6099949,2.0788691)"> '+
            '<g   transform="matrix(0.26458333,0,0,0.26458333,-1.3229164,-1.3229166)"  > '+
              '<path   d="m 43.689453,0 c -0.483,0 -0.875,0.39004688 -0.875,0.87304688 V 22.71875 c 0,0.483 0.392,0.873047 0.875,0.873047 h 2.621094 c 0.483,0 0.873047,-0.390047 0.873047,-0.873047 V 4.4277344 C 68.576592,5.5667344 85.632812,23.329 85.632812,45 c 0,3.068197 -0.352999,6.053883 -1.003906,8.927734 h 4.466797 C 89.683122,51.041002 90,48.057644 90,45 90,20.187 69.813,0 45,0 Z M 13.179688,13.541016 c -0.22275,5e-4 -0.444329,0.08822 -0.611329,0.261718 C 4.45636,22.228734 0,33.271 0,45 c 0,24.813 20.188,45 45,45 4.467599,0 8.780639,-0.664582 12.857422,-1.882812 V 83.53125 C 53.813309,84.88557 49.493988,85.632812 45,85.632812 22.596,85.632812 4.3671875,67.404 4.3671875,45 c 0,-10.562 4.0040159,-20.508422 11.2910155,-28.107422 0.334,-0.348 0.333176,-0.900187 -0.0078,-1.242187 l -1.853516,-1.853516 c -0.171,-0.1705 -0.394439,-0.256359 -0.617187,-0.255859 z" transform="translate(4.9999991,4.9999998)" /> '+
              '<path d="m 45.939,48.411 c -0.192,0.494 -0.308,1.026 -0.308,1.589 0,2.413 1.955,4.368 4.368,4.368 0.563,0 1.095,-0.114 1.588,-0.308 l 5.211,5.21 c 0.342,0.341 0.895,0.341 1.236,0 l 1.235,-1.235 c 0.341,-0.342 0.341,-0.895 0,-1.236 l -5.211,-5.211 c 0.193,-0.493 0.309,-1.026 0.309,-1.588 0,-2.413 -1.955,-4.369 -4.368,-4.369 -0.563,0 -1.095,0.115 -1.589,0.309 L 31.464,28.993 c -0.341,-0.341 -0.894,-0.341 -1.234,0 l -1.236,1.236 c -0.342,0.341 -0.342,0.895 0,1.235 z" /> '+
            '</g> '+
            '<rect     width="6" height="6"     x="17.103424" y="16.725445" /> '+
          '</g> '+
        '</g> '+
      '</svg>' 
  },
  "hover":{
   // key:'wait',
    name:'Attendre',
    img:'<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">'+
          '<g>'+
            '<path d="m50 10c-22.102 0-40 17.898-40 40s17.898 40 40 40 40-17.898 40-40-17.898-40-40-40zm0 76.102c-19.898 0-36.102-16.199-36.102-36.102 0-19.898 16.203-36.102 36.102-36.102s36.102 16.203 36.102 36.102-16.203 36.102-36.102 36.102z"/>'+
            '<path d="m39.5 29.301c-4.3008 0-7.6992 3.5-7.6992 7.6992v26c0 4.3008 3.5 7.6992 7.6992 7.6992 4.3008 0 7.6992-3.5 7.6992-7.6992v-26c0-4.3008-3.5-7.6992-7.6992-7.6992zm3.8008 33.699c0 2.1016-1.6992 3.8008-3.8008 3.8008s-3.8008-1.6992-3.8008-3.8008v-26c0-2.1016 1.6992-3.8008 3.8008-3.8008s3.8008 1.6992 3.8008 3.8008z"/>'+
            '<path d="m60.5 29.301c-4.3008 0-7.6992 3.5-7.6992 7.6992v26c0 4.3008 3.5 7.6992 7.6992 7.6992 4.3008 0 7.6992-3.5 7.6992-7.6992v-26c0.10156-4.3008-3.3984-7.6992-7.6992-7.6992zm3.8984 33.699c0 2.1016-1.6992 3.8008-3.8008 3.8008-2.1016 0-3.8008-1.6992-3.8008-3.8008l0.003906-26c0-2.1016 1.6992-3.8008 3.8008-3.8008 2.1016 0 3.8008 1.6992 3.8008 3.8008z"/>'+
          '</g>'+
        '</svg>',
  },
  "rotateYaw":{
 //   key:'droneyaw',
    name:'Aircraft Yaw',
    img:
        '<svg  xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 20 20"  version="1.1" >   '+
          '<g > '+
            '<g  transform="matrix(-4.1476348,0,0,-4.1476348,83.123867,74.860505)" > '+
              '<path d="m 17.633145,17.434252 a 2.1634979,2.1634979 0 0 1 -1.314186,-0.370417 0.13333064,0.13333064 0 0 1 0.16219,-0.211666 1.9314583,1.9314583 0 0 0 1.151996,0.3175 2.8448,2.8448 0 0 0 0.811477,-0.110861 c 0.242887,-0.07435 0.323585,-0.153723 0.333375,-0.175418 a 0.13230748,0.13230748 0 0 1 0.255587,0.06853 c -0.0799,0.301889 -0.7747,0.482335 -1.400439,0.482335 z"  /> '+
              '<path d="m 16.340858,17.416538 a 0.13229167,0.13229167 0 0 1 -0.04409,-0.04164 l -0.471922,-0.714544 0.854545,0.05129 a 0.13229167,0.13229167 0 0 1 0.124117,0.140094 0.13229167,0.13229167 0 0 1 -0.140094,0.124117 l -0.326582,-0.0196 0.180267,0.273027 a 0.13229167,0.13229167 0 0 1 -0.03744,0.183383 0.13229167,0.13229167 0 0 1 -0.138804,0.0039 z" /> '+
              '<path d="m 18.528481,16.729121 a 0.13229167,0.13229167 0 0 1 0.05811,-0.01736 l 0.854774,-0.05142 -0.471693,0.714412 a 0.13229167,0.13229167 0 0 1 -0.183383,0.03744 0.13229167,0.13229167 0 0 1 -0.03744,-0.183384 l 0.180171,-0.272665 -0.326582,0.0196 a 0.13229167,0.13229167 0 0 1 -0.07395,-0.246625 z"  /> '+
              '<path d="m 17.633145,17.434252 a 2.1634979,2.1634979 0 0 1 -1.314186,-0.370417 0.13333064,0.13333064 0 0 1 0.16219,-0.211666 1.9314583,1.9314583 0 0 0 1.151996,0.3175 2.8448,2.8448 0 0 0 0.811477,-0.110861 c 0.242887,-0.07435 0.323585,-0.153723 0.333375,-0.175418 a 0.13230748,0.13230748 0 0 1 0.255587,0.06853 c -0.0799,0.301889 -0.7747,0.482335 -1.400439,0.482335 z"  /> '+
              '<path d="m 16.340858,17.416538 a 0.13229167,0.13229167 0 0 1 -0.04409,-0.04164 l -0.471922,-0.714544 0.854545,0.05129 a 0.13229167,0.13229167 0 0 1 0.124117,0.140094 0.13229167,0.13229167 0 0 1 -0.140094,0.124117 l -0.326582,-0.0196 0.180267,0.273027 a 0.13229167,0.13229167 0 0 1 -0.03744,0.183383 0.13229167,0.13229167 0 0 1 -0.138804,0.0039 z"  /> '+
              '<path d="m 18.528481,16.729121 a 0.13229167,0.13229167 0 0 1 0.05811,-0.01736 l 0.854774,-0.05142 -0.471693,0.714412 a 0.13229167,0.13229167 0 0 1 -0.183383,0.03744 0.13229167,0.13229167 0 0 1 -0.03744,-0.183384 l 0.180171,-0.272665 -0.326582,0.0196 a 0.13229167,0.13229167 0 0 1 -0.07395,-0.246625 z" /> '+
            '</g> '+
            '<path  d="M 3.8829904,16.354846 A 2.5586684,2.5573449 0 0 1 6.290355,13.800874 l 0.1507415,-0.0046 v 0.861819 a 1.6975294,1.6966514 0 1 0 1.6913422,1.823703 l 0.00505,-0.12705 h 0.8611415 a 2.5592312,2.5579075 0 1 1 -5.1184623,0 z m 6.8058646,0 h 0.861702 a 1.7070914,1.7062084 0 1 0 1.824087,-1.691592 l -0.127126,-0.0052 v -0.860071 a 2.5597934,2.5584693 0 1 1 -2.553606,2.708008 l -0.0046,-0.150102 z m 0,-6.8079688 a 2.5957914,2.5944488 0 1 1 2.708286,2.5545338 l -0.150741,0.0038 v -0.86122 A 1.6975294,1.6966514 0 1 0 11.55562,9.4202861 l -0.005,0.1270531 h -0.860636 z m -6.8058646,0 A 2.5581061,2.5567827 0 0 1 8.9947022,9.3967751 l 0.0046,0.1501021 H 8.1375009 A 1.7070914,1.7062084 0 1 0 6.3145411,11.238469 l 0.1271174,0.005 v 0.861878 A 2.5586684,2.5573449 0 0 1 3.8829904,9.5474402 Z M 12.767176,9.4316291 a 0.46797366,0.4677316 0 1 1 0.524784,0.6251419 1.8488334,1.8478771 0 0 0 -0.337482,0.291208 c -0.09731,0.09557 -0.266047,0.325501 -0.473597,0.588038 a 3.7364771,3.7345444 0 0 0 -0.956197,1.993481 3.1278865,3.1262686 0 0 0 0.736271,1.665731 c 0.09563,0.137176 0.294171,0.40027 0.551219,0.744323 a 2.2937459,2.2925595 0 0 0 0.609153,0.546998 l -0.0044,0.0046 A 0.47022353,0.4699803 0 1 1 12.751488,16.429676 1.0158178,1.0152924 0 0 0 12.39207,15.923716 11.159372,11.1536 0 0 0 11.492121,15.212562 3.0255173,3.0239522 0 0 0 9.9239592,14.491288 2.7240342,2.7226251 0 0 0 8.4052959,15.158031 C 8.2281184,15.277203 7.8990745,15.533002 7.5812797,15.791043 A 2.5479815,2.5466636 0 0 0 6.893381,16.54155 v 0 A 0.46853613,0.46829378 0 1 1 6.4017237,15.848323 2.9175233,2.9160142 0 0 0 7.1177459,15.213064 c 0,0 0.4319756,-0.575107 0.5281577,-0.721275 A 2.8432774,2.8418067 0 0 0 7.5862821,11.244654 C 7.3134849,10.912407 6.8831966,10.351353 6.8831966,10.351353 A 1.367923,1.3672155 0 0 0 6.458533,10.066891 0.47078601,0.47054249 0 1 1 6.9085078,9.3984611 v 0 a 1.3572362,1.356534 0 0 0 0.4353503,0.4761661 c 0,0 0.4173517,0.2973918 0.8780131,0.6577468 a 3.0176426,3.0160818 0 0 0 1.7661499,0.805038 3.0513908,3.0498124 0 0 0 1.7025909,-0.862942 5.3676353,5.3648589 0 0 0 0.836953,-0.7072198 1.2936772,1.293008 0 0 0 0.240174,-0.3305621 z"   />'+
          '</g> '+
        '</svg>',
  },
  "gimbalTilt":{
   // key:'camera',
    name:'Gimbal Tilt',
    img:
        '<svg   xmlns="http://www.w3.org/2000/svg"     viewBox="0 0 20 20"   version="1.1" > ' +
          '<g  transform="translate(-98.009448,-87.514304)" > ' +
            '<path d="m 112.59616,95.069634 c -0.28277,-0.172383 -0.62529,-0.185997 -0.92166,-0.03855 l -1.82367,0.793892 v -0.956442 c 0,-0.687276 -0.55948,-1.246765 -1.24676,-1.246765 h -6.85459 c -0.68728,0 -1.24677,0.559489 -1.24677,1.246765 V 100.375 c 0,0.68728 0.55949,1.24677 1.24677,1.24677 h 6.85613 c 0.68729,0 1.24678,-0.55949 1.24678,-1.24677 v -1.006334 l 1.81156,0.820354 c 0.13912,0.0718 0.28807,0.1066 0.43777,0.1066 0.1686,0 0.33872,-0.0461 0.48992,-0.13761 0.29034,-0.173892 0.46423,-0.480112 0.46423,-0.818833 l -7.3e-4,-3.45458 c 0,-0.337215 -0.17239,-0.641152 -0.45894,-0.815048 z m -3.99287,5.778026 h -6.85381 c -0.26161,0 -0.47255,-0.21094 -0.47255,-0.47255 v -5.508789 c 0,-0.261609 0.21094,-0.472544 0.47255,-0.472544 h 6.85613 c 0.26161,0 0.47256,0.210935 0.47256,0.472544 v 1.550709 0.0022 3.95434 c -7.4e-4,0.26086 -0.21323,0.47406 -0.47482,0.47406 z m 3.67756,-1.506093 c 0,0.08921 -0.0544,0.135336 -0.0869,0.154993 -0.0333,0.01968 -0.0991,0.04609 -0.17844,0.0037 -0.008,-0.0037 -0.0151,-0.0075 -0.0234,-0.01134 l -2.14053,-0.971556 v -1.850125 l 2.14266,-0.932996 c 0.008,-0.0037 0.0151,-0.0075 0.0234,-0.01134 0.0771,-0.04082 0.1429,-0.01361 0.17617,0.0059 0.0333,0.01968 0.0869,0.06577 0.0869,0.152725 z"  /> ' +
          '</g> ' +
          '<g > ' +
            '<g transform="matrix(0,-4.1476348,4.1476348,0,-53.343611,83.318358)"> ' +
              '<path  d="m 17.633145,17.434252 a 2.1634979,2.1634979 0 0 1 -1.314186,-0.370417 0.13333064,0.13333064 0 0 1 0.16219,-0.211666 1.9314583,1.9314583 0 0 0 1.151996,0.3175 2.8448,2.8448 0 0 0 0.811477,-0.110861 c 0.242887,-0.07435 0.323585,-0.153723 0.333375,-0.175418 a 0.13230748,0.13230748 0 0 1 0.255587,0.06853 c -0.0799,0.301889 -0.7747,0.482335 -1.400439,0.482335 z"  /> ' +
              '<path  d="m 16.340858,17.416538 a 0.13229167,0.13229167 0 0 1 -0.04409,-0.04164 l -0.471922,-0.714544 0.854545,0.05129 a 0.13229167,0.13229167 0 0 1 0.124117,0.140094 0.13229167,0.13229167 0 0 1 -0.140094,0.124117 l -0.326582,-0.0196 0.180267,0.273027 a 0.13229167,0.13229167 0 0 1 -0.03744,0.183383 0.13229167,0.13229167 0 0 1 -0.138804,0.0039 z"  /> ' +
              '<path  d="m 18.528481,16.729121 a 0.13229167,0.13229167 0 0 1 0.05811,-0.01736 l 0.854774,-0.05142 -0.471693,0.714412 a 0.13229167,0.13229167 0 0 1 -0.183383,0.03744 0.13229167,0.13229167 0 0 1 -0.03744,-0.183384 l 0.180171,-0.272665 -0.326582,0.0196 a 0.13229167,0.13229167 0 0 1 -0.07395,-0.246625 z" /> ' +
              '<path  d="m 17.633145,17.434252 a 2.1634979,2.1634979 0 0 1 -1.314186,-0.370417 0.13333064,0.13333064 0 0 1 0.16219,-0.211666 1.9314583,1.9314583 0 0 0 1.151996,0.3175 2.8448,2.8448 0 0 0 0.811477,-0.110861 c 0.242887,-0.07435 0.323585,-0.153723 0.333375,-0.175418 a 0.13230748,0.13230748 0 0 1 0.255587,0.06853 c -0.0799,0.301889 -0.7747,0.482335 -1.400439,0.482335 z"  /> ' +
              '<path  d="m 16.340858,17.416538 a 0.13229167,0.13229167 0 0 1 -0.04409,-0.04164 l -0.471922,-0.714544 0.854545,0.05129 a 0.13229167,0.13229167 0 0 1 0.124117,0.140094 0.13229167,0.13229167 0 0 1 -0.140094,0.124117 l -0.326582,-0.0196 0.180267,0.273027 a 0.13229167,0.13229167 0 0 1 -0.03744,0.183383 0.13229167,0.13229167 0 0 1 -0.138804,0.0039 z" /> ' +
              '<path  d="m 18.528481,16.729121 a 0.13229167,0.13229167 0 0 1 0.05811,-0.01736 l 0.854774,-0.05142 -0.471693,0.714412 a 0.13229167,0.13229167 0 0 1 -0.183383,0.03744 0.13229167,0.13229167 0 0 1 -0.03744,-0.183384 l 0.180171,-0.272665 -0.326582,0.0196 a 0.13229167,0.13229167 0 0 1 -0.07395,-0.246625 z" />' +
            '</g> ' +
          '</g> ' +
        '</svg>  ',
  },
  "gimbalYaw":{
   // key:'camera',
    name:'Gimbal Yaw',
    img:
        '<svg   xmlns="http://www.w3.org/2000/svg"     viewBox="0 0 20 20"   version="1.1" transform="rotate(-90)"> ' +
          '<g  transform="translate(-98.009448,-87.514304) " > ' +
            '<path d="m 112.59616,95.069634 c -0.28277,-0.172383 -0.62529,-0.185997 -0.92166,-0.03855 l -1.82367,0.793892 v -0.956442 c 0,-0.687276 -0.55948,-1.246765 -1.24676,-1.246765 h -6.85459 c -0.68728,0 -1.24677,0.559489 -1.24677,1.246765 V 100.375 c 0,0.68728 0.55949,1.24677 1.24677,1.24677 h 6.85613 c 0.68729,0 1.24678,-0.55949 1.24678,-1.24677 v -1.006334 l 1.81156,0.820354 c 0.13912,0.0718 0.28807,0.1066 0.43777,0.1066 0.1686,0 0.33872,-0.0461 0.48992,-0.13761 0.29034,-0.173892 0.46423,-0.480112 0.46423,-0.818833 l -7.3e-4,-3.45458 c 0,-0.337215 -0.17239,-0.641152 -0.45894,-0.815048 z m -3.99287,5.778026 h -6.85381 c -0.26161,0 -0.47255,-0.21094 -0.47255,-0.47255 v -5.508789 c 0,-0.261609 0.21094,-0.472544 0.47255,-0.472544 h 6.85613 c 0.26161,0 0.47256,0.210935 0.47256,0.472544 v 1.550709 0.0022 3.95434 c -7.4e-4,0.26086 -0.21323,0.47406 -0.47482,0.47406 z m 3.67756,-1.506093 c 0,0.08921 -0.0544,0.135336 -0.0869,0.154993 -0.0333,0.01968 -0.0991,0.04609 -0.17844,0.0037 -0.008,-0.0037 -0.0151,-0.0075 -0.0234,-0.01134 l -2.14053,-0.971556 v -1.850125 l 2.14266,-0.932996 c 0.008,-0.0037 0.0151,-0.0075 0.0234,-0.01134 0.0771,-0.04082 0.1429,-0.01361 0.17617,0.0059 0.0333,0.01968 0.0869,0.06577 0.0869,0.152725 z"  /> ' +
          '</g> ' +
          '<g > ' +
            '<g transform="matrix(0,-4.1476348,4.1476348,0,-53.343611,83.318358)"> ' +
              '<path  d="m 17.633145,17.434252 a 2.1634979,2.1634979 0 0 1 -1.314186,-0.370417 0.13333064,0.13333064 0 0 1 0.16219,-0.211666 1.9314583,1.9314583 0 0 0 1.151996,0.3175 2.8448,2.8448 0 0 0 0.811477,-0.110861 c 0.242887,-0.07435 0.323585,-0.153723 0.333375,-0.175418 a 0.13230748,0.13230748 0 0 1 0.255587,0.06853 c -0.0799,0.301889 -0.7747,0.482335 -1.400439,0.482335 z"  /> ' +
              '<path  d="m 16.340858,17.416538 a 0.13229167,0.13229167 0 0 1 -0.04409,-0.04164 l -0.471922,-0.714544 0.854545,0.05129 a 0.13229167,0.13229167 0 0 1 0.124117,0.140094 0.13229167,0.13229167 0 0 1 -0.140094,0.124117 l -0.326582,-0.0196 0.180267,0.273027 a 0.13229167,0.13229167 0 0 1 -0.03744,0.183383 0.13229167,0.13229167 0 0 1 -0.138804,0.0039 z"  /> ' +
              '<path  d="m 18.528481,16.729121 a 0.13229167,0.13229167 0 0 1 0.05811,-0.01736 l 0.854774,-0.05142 -0.471693,0.714412 a 0.13229167,0.13229167 0 0 1 -0.183383,0.03744 0.13229167,0.13229167 0 0 1 -0.03744,-0.183384 l 0.180171,-0.272665 -0.326582,0.0196 a 0.13229167,0.13229167 0 0 1 -0.07395,-0.246625 z" /> ' +
              '<path  d="m 17.633145,17.434252 a 2.1634979,2.1634979 0 0 1 -1.314186,-0.370417 0.13333064,0.13333064 0 0 1 0.16219,-0.211666 1.9314583,1.9314583 0 0 0 1.151996,0.3175 2.8448,2.8448 0 0 0 0.811477,-0.110861 c 0.242887,-0.07435 0.323585,-0.153723 0.333375,-0.175418 a 0.13230748,0.13230748 0 0 1 0.255587,0.06853 c -0.0799,0.301889 -0.7747,0.482335 -1.400439,0.482335 z"  /> ' +
              '<path  d="m 16.340858,17.416538 a 0.13229167,0.13229167 0 0 1 -0.04409,-0.04164 l -0.471922,-0.714544 0.854545,0.05129 a 0.13229167,0.13229167 0 0 1 0.124117,0.140094 0.13229167,0.13229167 0 0 1 -0.140094,0.124117 l -0.326582,-0.0196 0.180267,0.273027 a 0.13229167,0.13229167 0 0 1 -0.03744,0.183383 0.13229167,0.13229167 0 0 1 -0.138804,0.0039 z" /> ' +
              '<path  d="m 18.528481,16.729121 a 0.13229167,0.13229167 0 0 1 0.05811,-0.01736 l 0.854774,-0.05142 -0.471693,0.714412 a 0.13229167,0.13229167 0 0 1 -0.183383,0.03744 0.13229167,0.13229167 0 0 1 -0.03744,-0.183384 l 0.180171,-0.272665 -0.326582,0.0196 a 0.13229167,0.13229167 0 0 1 -0.07395,-0.246625 z" />' +
            '</g> ' +
          '</g> ' +
        '</svg>  ',
  },
  "zoom":{
    // key:'zoom',
     name:'Camera Zoom',
     img:
         '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0">'+
         '<g>'+
          '<path d="m17.172 71.102c7.4297 7.4297 17.199 11.148 26.969 11.148 8.1914 0 16.379-2.6289 23.191-7.8594l18.141 18.141c0.98047 0.98047 2.2617 1.4609 3.5391 1.4609 1.2812 0 2.5586-0.48828 3.5391-1.4609 1.9492-1.9492 1.9492-5.1211 0-7.0703l-18.141-18.141c11.469-14.941 10.371-36.488-3.3008-50.16-14.871-14.871-39.059-14.871-53.93 0-14.871 14.871-14.871 39.059 0 53.93zm7.0664-46.863c5.4883-5.4805 12.691-8.2305 19.898-8.2305 7.2109 0 14.41 2.7383 19.898 8.2305 10.969 10.969 10.969 28.82 0 39.789s-28.82 10.969-39.789 0-10.969-28.82 0-39.789z"/>'+
          '<path d="m29.488 49.141h9.6406v9.6406c0 2.7617 2.2383 5 5 5 2.7617 0 5-2.2383 5-5v-9.6406h9.6406c2.7617 0 5-2.2383 5-5s-2.2383-5-5-5h-9.6406v-9.6406c0-2.7617-2.2383-5-5-5-2.7617 0-5 2.2383-5 5v9.6406h-9.6406c-2.7617 0-5 2.2383-5 5s2.2383 5 5 5z"/>'+
         '</g>'+
        '</svg>',
  },
  "panoShot":{
    // key:'pano',
    name:'Panorama 360',
    img:
        '<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 128 160" x="0px" y="0px">'+
        '<title>360</title>'+
        '<path d="M50.3,49.083a3.7,3.7,0,0,0,2.909-3.6c0-2.474-2.223-4.305-5.932-4.305A7.712,7.712,0,0,0,41.1,43.977l2.2,2.381a5.059,5.059,0,0,1,3.573-1.672c1.42,0,2.359.573,2.359,1.535,0,.917-.849,1.443-2.429,1.421H44.944v3.3l1.854-.023c1.992,0,2.749.5,2.749,1.488,0,.916-.871,1.58-2.451,1.58a5.746,5.746,0,0,1-4.077-1.717l-2.244,2.587A8.534,8.534,0,0,0,47.3,57.489c3.8,0,6.253-1.97,6.253-4.742A3.826,3.826,0,0,0,50.3,49.083Z"/>'+
        '<path d="M65.236,46.908a5.969,5.969,0,0,0-3.642,1.236c.344-2.221,1.535-3.55,3.39-3.55A4.674,4.674,0,0,1,68.1,45.786l1.809-2.954a7.839,7.839,0,0,0-4.946-1.649c-4.6,0-7.512,3.436-7.512,8.427,0,4.627,2.221,7.855,6.916,7.855,3.5,0,6.183-2.2,6.183-5.518A4.98,4.98,0,0,0,65.236,46.908Zm-1.1,7.237c-1.6,0-2.29-.847-2.543-2.588a2.647,2.647,0,0,1,2.451-1.512,2.231,2.231,0,0,1,2.5,2.062A2.164,2.164,0,0,1,64.138,54.145Z"/>'+
        '<path d="M81.911,41.183c-4.238,0-7.238,3.366-7.238,8.129,0,4.787,3,8.153,7.238,8.153,4.259,0,7.237-3.366,7.237-8.153C89.148,44.549,86.17,41.183,81.911,41.183Zm0,12.733c-1.878,0-3.207-1.923-3.207-4.6s1.329-4.579,3.207-4.579c1.9,0,3.228,1.9,3.228,4.579S83.812,53.915,81.911,53.915Z"/><path d="M64.962,24.936H63.038c-22.591,0-56.744,9.083-56.744,22.774V86.546c0,10.778,15.213,16.519,26.194,16.519a2,2,0,0,0,2-2V73.151A95.477,95.477,0,0,1,64,68.476a100.825,100.825,0,0,1,29.512,4.68v27.909a2,2,0,0,0,2,2c10.981,0,26.194-5.74,26.194-16.519V47.71C121.706,34.019,87.553,24.936,64.962,24.936ZM30.488,99c-9.019-.614-20.194-5.237-20.194-12.449V56.411c.292.3.6.592.925.881.073.065.149.128.223.193q.573.5,1.2.975c.057.043.11.087.168.129.456.335.939.657,1.439.97.111.069.222.138.335.206.508.307,1.034.605,1.585.888.08.041.164.079.245.119q.781.391,1.617.745c.1.041.192.085.291.125.6.247,1.225.477,1.866.693.138.047.277.091.416.136.66.213,1.335.414,2.035.591.059.015.121.027.181.042.669.166,1.359.313,2.063.444.136.026.27.053.408.077q1.1.194,2.258.327c.156.018.314.033.471.049.806.084,1.624.153,2.466.191V99ZM64,64.476a100.83,100.83,0,0,0-29.512,4.457V62.24a2,2,0,0,0-2-2c-10.861,0-17.915-4.094-20.763-8.356a7.647,7.647,0,0,1-1.431-4.174c0-9.492,30.2-18.774,52.744-18.774h1.924c22.543,0,52.744,9.282,52.744,18.774,0,5.253-7.713,12.53-22.194,12.53a2,2,0,0,0-2,2v6.7A106.752,106.752,0,0,0,64,64.476Zm53.706,22.07c0,7.212-11.176,11.835-20.194,12.449V64.2h0c.84-.038,1.655-.107,2.458-.19.159-.016.319-.032.476-.05q1.153-.134,2.253-.326c.14-.025.277-.052.415-.079.7-.131,1.386-.277,2.051-.442.062-.016.127-.029.189-.044.7-.177,1.371-.377,2.029-.59.142-.046.283-.091.423-.139.639-.216,1.261-.445,1.86-.691.1-.042.2-.086.3-.128q.831-.352,1.608-.741c.083-.041.169-.08.251-.122.549-.282,1.074-.579,1.581-.885.114-.069.227-.139.339-.209.5-.313.981-.634,1.436-.968.059-.043.113-.088.171-.132q.631-.473,1.2-.972c.075-.065.152-.128.225-.194.322-.289.633-.581.924-.881Z"/>'+
        '</svg>'
  },
  "takePhoto":{
   // key:'snapshot',
    name:'Prendre une photo',
    img:'<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0">'+
          '<g>'+
            '<path d="m76.109 40.145c1.8555 0 3.3477-1.4922 3.3477-3.3086 0-1.8555-1.4922-3.3438-3.3477-3.3438-1.8164 0-3.3086 1.4922-3.3086 3.3438 0 1.8164 1.4883 3.3086 3.3086 3.3086z"/>'+
            '<path d="m50 32c-9.9258 0-18 8.0742-18 18s8.0742 18 18 18 18-8.0742 18-18-8.0742-18-18-18zm0 30c-6.6172 0-12-5.3828-12-12s5.3828-12 12-12 12 5.3828 12 12-5.3828 12-12 12z"/>'+
            '<path d="m83 23h-13.395l-5.1094-7.6641c-0.55469-0.83594-1.4922-1.3359-2.4961-1.3359h-24c-1.0039 0-1.9414 0.5-2.4961 1.3359l-5.1094 7.6641h-13.395c-4.9609 0-9 4.0391-9 9v39c0 4.9609 4.0391 9 9 9h66c4.9609 0 9-4.0391 9-9v-39c0-4.9609-4.0391-9-9-9zm3 48c0 1.6523-1.3477 3-3 3h-66c-1.6523 0-3-1.3477-3-3v-39c0-1.6523 1.3477-3 3-3h15c1.0039 0 1.9414-0.5 2.4961-1.3359l5.1094-7.6641h20.789l5.1094 7.6641c0.55469 0.83594 1.4922 1.3359 2.4961 1.3359h15c1.6523 0 3 1.3477 3 3z"/>'+
          '</g>'+
        '</svg>',
  },
  "orientedShoot":{
   // key:'snapshotfixedangle',
    name:'Prendre une photo avec une orientation fixe',
    img:'<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0">'+
          '<defs>'+
            '<clipPath id="clipPath6">'+
            '<rect style="display:none;" id="rect6" width="35.0" height="38.0" x="58.0" y="45.0" clip-path="none" />'+
            '<path class="powerclip" d="m 2.999,9 h 94 v 76 h -94 z m 54.768532,36.461254 v 37.859779 h 35.0369 V 45.461254 Z" />'+
            '</clipPath>'+
          '</defs>'+
          '<g clip-path="url(#clipPath6)">'+
            '<path d="m76.109 40.145c1.8555 0 3.3477-1.4922 3.3477-3.3086 0-1.8555-1.4922-3.3438-3.3477-3.3438-1.8164 0-3.3086 1.4922-3.3086 3.3438 0 1.8164 1.4883 3.3086 3.3086 3.3086z"/>'+
            '<path d="m50 32c-9.9258 0-18 8.0742-18 18s8.0742 18 18 18 18-8.0742 18-18-8.0742-18-18-18zm0 30c-6.6172 0-12-5.3828-12-12s5.3828-12 12-12 12 5.3828 12 12-5.3828 12-12 12z"/>'+
            '<path d="m83 23h-13.395l-5.1094-7.6641c-0.55469-0.83594-1.4922-1.3359-2.4961-1.3359h-24c-1.0039 0-1.9414 0.5-2.4961 1.3359l-5.1094 7.6641h-13.395c-4.9609 0-9 4.0391-9 9v39c0 4.9609 4.0391 9 9 9h66c4.9609 0 9-4.0391 9-9v-39c0-4.9609-4.0391-9-9-9zm3 48c0 1.6523-1.3477 3-3 3h-66c-1.6523 0-3-1.3477-3-3v-39c0-1.6523 1.3477-3 3-3h15c1.0039 0 1.9414-0.5 2.4961-1.3359l5.1094-7.6641h20.789l5.1094 7.6641c0.55469 0.83594 1.4922 1.3359 2.4961 1.3359h15c1.6523 0 3 1.3477 3 3z"/>'+
          '</g>'+
          '<text transform="scale(1.169393,0.8551445)">'+
          '<tspan sodipodi:role="line" x="50.0" y="93.0" style="font-weight:bold;font-size:49px;font-family:Arial;-inkscape-font-specification:\'Arial, Bold\';stroke-width:0.5;fill-opacity:1;stroke-opacity:0.5">F</tspan>'+
          '</text>'+
          
        '</svg>',
  },
  "customDirName":{
    //key:'directory',
    name:'Créer un dossier',
    img:'<svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 95 118.75" >'+
        '<path d="M73.05,44.38c-1.18,0-2.34,0.1-3.47,0.28V23.1c0-4.78-3.88-8.67-8.66-8.67H31.9l-2.04-3.46c-1.6-2.71-4.32-4.27-7.47-4.27  H8.67C3.89,6.7,0,10.58,0,15.37v41.62c0,4.78,3.89,8.67,8.67,8.67H51.1c-0.01,0.23-0.02,0.46-0.02,0.69  c0,12.11,9.85,21.96,21.97,21.96C85.15,88.3,95,78.45,95,66.34C95,54.23,85.15,44.38,73.05,44.38z M8.67,11.15h13.72  c1.55,0,2.84,0.74,3.63,2.07l2.69,4.56c0.4,0.68,1.13,1.1,1.92,1.1h30.29c2.32,0,4.2,1.89,4.2,4.22v4.51H4.45V15.37  C4.45,13.04,6.34,11.15,8.67,11.15z M8.67,61.2c-2.33,0-4.22-1.89-4.22-4.22V32.06h60.67v13.8c-6.65,2.58-11.74,8.3-13.43,15.34  H8.67z M73.05,83.85c-9.66,0-17.51-7.85-17.51-17.51c0-9.65,7.86-17.51,17.51-17.51c9.65,0,17.5,7.85,17.5,17.51  C90.55,76,82.7,83.85,73.05,83.85z M82.54,66.34c0,1.23-1,2.23-2.23,2.23h-5.04v5.05c0,1.23-1,2.23-2.23,2.23s-2.23-1-2.23-2.23  v-5.05h-5.05c-1.23,0-2.23-1-2.23-2.23s1-2.23,2.23-2.23h5.05v-5.05c0-1.23,1-2.23,2.23-2.23s2.23,1,2.23,2.23v5.05h5.04  C81.54,64.12,82.54,65.11,82.54,66.34z"/>'+
        '</svg>',
  },
};

  

export const droneYaw={
  default:0,
  min:-180,
  max:180,
  step:0.1,
};


export const cameraYaw={
  default:0,
  min:-180,
  max:180,
  step:0.1,
};
export const cameraTilt={
  default:0,
  min:-90,
  max:30,
  step:0.1,
};
export const cameraZoom={
  default:2,
  min:2,
  max:56,
  step:1,
};


export const TimedIntervalShot={
  min:1,
  max: 30,
}
export const DistanceIntervalShot={
  min:1,
  max: 100,
}
export const Hover={
  min:1,
  max: 9999,
}